
export const zipCodeCenters: { [key: string]: { lat: number; lon: number } } = {
  // Manhattan
  "10001": { lat: 40.7505, lon: -73.9934 }, "10002": { lat: 40.7153, lon: -73.9882 },
  "10003": { lat: 40.7318, lon: -73.9892 }, "10004": { lat: 40.7034, lon: -74.0131 },
  "10005": { lat: 40.7058, lon: -74.0089 }, "10006": { lat: 40.7091, lon: -74.0121 },
  "10007": { lat: 40.713, lon: -74.0095 }, "10009": { lat: 40.7262, lon: -73.9782 },
  "10010": { lat: 40.7405, lon: -73.9861 }, "10011": { lat: 40.7423, lon: -74.0003 },
  "10012": { lat: 40.7255, lon: -73.9959 }, "10013": { lat: 40.7193, lon: -74.0086 },
  "10014": { lat: 40.7348, lon: -74.0049 }, "10016": { lat: 40.746, lon: -73.979 },
  "10017": { lat: 40.7523, lon: -73.9739 }, "10018": { lat: 40.7554, lon: -73.9912 },
  "10019": { lat: 40.7645, lon: -73.9831 }, "10020": { lat: 40.7587, lon: -73.9787 },
  "10021": { lat: 40.7715, lon: -73.9589 }, "10022": { lat: 40.758, lon: -73.966 },
  "10023": { lat: 40.7788, lon: -73.9814 }, "10024": { lat: 40.785, lon: -73.9722 },
  "10025": { lat: 40.7983, lon: -73.9686 }, "10026": { lat: 40.8034, lon: -73.9546 },
  "10027": { lat: 40.8123, lon: -73.9535 }, "10028": { lat: 40.7774, lon: -73.9531 },
  "10029": { lat: 40.792, lon: -73.945 }, "10030": { lat: 40.818, lon: -73.944 },
  "10031": { lat: 40.826, lon: -73.950 }, "10032": { lat: 40.838, lon: -73.943 },
  "10033": { lat: 40.849, lon: -73.936 }, "10034": { lat: 40.865, lon: -73.924 },
  "10035": { lat: 40.795, lon: -73.933 }, "10036": { lat: 40.759, lon: -73.9845 },
  "10037": { lat: 40.812, lon: -73.939 }, "10038": { lat: 40.709, lon: -74.004 },
  "10039": { lat: 40.826, lon: -73.938 }, "10040": { lat: 40.858, lon: -73.93 },
  "10044": { lat: 40.76, lon: -73.948 }, "10065": { lat: 40.767, lon: -73.963 },
  "10075": { lat: 40.774, lon: -73.958 }, "10128": { lat: 40.783, lon: -73.951 },
  "10280": { lat: 40.71, lon: -74.015 }, "10282": { lat: 40.715, lon: -74.016 },
  // Brooklyn
  "11201": { lat: 40.6934, lon: -73.9918 }, "11203": { lat: 40.65, lon: -73.933 },
  "11204": { lat: 40.62, lon: -73.984 }, "11205": { lat: 40.6948, lon: -73.9673 },
  "11206": { lat: 40.7001, lon: -73.9452 }, "11207": { lat: 40.665, lon: -73.895 },
  "11208": { lat: 40.675, lon: -73.87 }, "11209": { lat: 40.625, lon: -74.03 },
  "11210": { lat: 40.627, lon: -73.95 }, "11211": { lat: 40.7081, lon: -73.9571 },
  "11212": { lat: 40.665, lon: -73.915 }, "11213": { lat: 40.67, lon: -73.94 },
  "11214": { lat: 40.595, lon: -73.996 }, "11215": { lat: 40.6657, lon: -73.9821 },
  "11216": { lat: 40.6789, lon: -73.9535 }, "11217": { lat: 40.686, lon: -73.9789 },
  "11218": { lat: 40.645, lon: -73.976 }, "11219": { lat: 40.635, lon: -73.995 },
  "11220": { lat: 40.64, lon: -74.015 }, "11221": { lat: 40.6912, lon: -73.9298 },
  "11222": { lat: 40.726, lon: -73.9505 }, "11223": { lat: 40.6, lon: -73.97 },
  "11224": { lat: 40.578, lon: -73.98 }, "11225": { lat: 40.66, lon: -73.96 },
  "11226": { lat: 40.645, lon: -73.958 }, "11228": { lat: 40.615, lon: -74.01 },
  "11229": { lat: 40.6, lon: -73.945 }, "11230": { lat: 40.625, lon: -73.965 },
  "11231": { lat: 40.679, lon: -74.0031 }, "11232": { lat: 40.655, lon: -74.005 },
  "11233": { lat: 40.675, lon: -73.92 }, "11234": { lat: 40.615, lon: -73.92 },
  "11235": { lat: 40.583, lon: -73.955 }, "11236": { lat: 40.635, lon: -73.91 },
  "11237": { lat: 40.704, lon: -73.924 }, "11238": { lat: 40.678, lon: -73.9626 },
  "11239": { lat: 40.65, lon: -73.88 },
  // Queens
  "11004": { lat: 40.74, lon: -73.71 }, "11101": { lat: 40.7447, lon: -73.9485 },
  "11102": { lat: 40.7725, lon: -73.9221 }, "11103": { lat: 40.7656, lon: -73.9135 },
  "11104": { lat: 40.7479, lon: -73.9189 }, "11105": { lat: 40.7779, lon: -73.9067 },
  "11106": { lat: 40.7624, lon: -73.9312 }, "11354": { lat: 40.765, lon: -73.83 },
  "11355": { lat: 40.755, lon: -73.82 }, "11356": { lat: 40.78, lon: -73.84 },
  "11357": { lat: 40.79, lon: -73.83 }, "11358": { lat: 40.76, lon: -73.8 },
  "11360": { lat: 40.78, lon: -73.79 }, "11361": { lat: 40.765, lon: -73.77 },
  "11362": { lat: 40.755, lon: -73.75 }, "11363": { lat: 40.77, lon: -73.75 },
  "11364": { lat: 40.745, lon: -73.76 }, "11365": { lat: 40.735, lon: -73.8 },
  "11366": { lat: 40.725, lon: -73.79 }, "11367": { lat: 40.725, lon: -73.82 },
  "11368": { lat: 40.745, lon: -73.85 }, "11369": { lat: 40.765, lon: -73.875 },
  "11370": { lat: 40.76, lon: -73.89 }, "11372": { lat: 40.75, lon: -73.885 },
  "11373": { lat: 40.737, lon: -73.875 }, "11374": { lat: 40.725, lon: -73.855 },
  "11375": { lat: 40.7188, lon: -73.8447 }, "11377": { lat: 40.745, lon: -73.9 },
  "11378": { lat: 40.73, lon: -73.9 }, "11379": { lat: 40.725, lon: -73.89 },
  "11385": { lat: 40.7005, lon: -73.8995 }, "11412": { lat: 40.69, lon: -73.76 },
  "11413": { lat: 40.67, lon: -73.75 }, "11414": { lat: 40.66, lon: -73.84 },
  "11415": { lat: 40.7, lon: -73.83 }, "11416": { lat: 40.68, lon: -73.845 },
  "11417": { lat: 40.68, lon: -73.83 }, "11418": { lat: 40.695, lon: -73.83 },
  "11419": { lat: 40.69, lon: -73.82 }, "11420": { lat: 40.67, lon: -73.81 },
  "11421": { lat: 40.695, lon: -73.85 }, "11422": { lat: 40.66, lon: -73.74 },
  "11423": { lat: 40.71, lon: -73.77 }, "11426": { lat: 40.73, lon: -73.72 },
  "11427": { lat: 40.72, lon: -73.74 }, "11428": { lat: 40.715, lon: -73.73 },
  "11429": { lat: 40.7, lon: -73.73 }, "11432": { lat: 40.7121, lon: -73.7944 },
  "11433": { lat: 40.7, lon: -73.78 }, "11434": { lat: 40.68, lon: -73.77 },
  "11435": { lat: 40.7, lon: -73.81 }, "11436": { lat: 40.685, lon: -73.8 },
  "11691": { lat: 40.59, lon: -73.76 }, "11692": { lat: 40.59, lon: -73.8 },
  "11693": { lat: 40.575, lon: -73.85 }, "11694": { lat: 40.56, lon: -73.91 },
  "11697": { lat: 40.56, lon: -73.93 },
  // Bronx
  "10451": { lat: 40.8213, lon: -73.9248 }, "10452": { lat: 40.835, lon: -73.92 },
  "10453": { lat: 40.848, lon: -73.91 }, "10454": { lat: 40.8099, lon: -73.9197 },
  "10455": { lat: 40.815, lon: -73.905 }, "10456": { lat: 40.83, lon: -73.908 },
  "10457": { lat: 40.845, lon: -73.9 }, "10458": { lat: 40.86, lon: -73.89 },
  "10459": { lat: 40.825, lon: -73.89 }, "10460": { lat: 40.84, lon: -73.88 },
  "10461": { lat: 40.8493, lon: -73.8425 }, "10462": { lat: 40.84, lon: -73.86 },
  "10463": { lat: 40.884, lon: -73.9056 }, "10464": { lat: 40.84, lon: -73.79 },
  "10465": { lat: 40.82, lon: -73.82 }, "10466": { lat: 40.89, lon: -73.85 },
  "10467": { lat: 40.8787, lon: -73.8732 }, "10468": { lat: 40.87, lon: -73.9 },
  "10469": { lat: 40.87, lon: -73.84 }, "10470": { lat: 40.9, lon: -73.86 },
  "10471": { lat: 40.9038, lon: -73.9015 }, "10472": { lat: 40.83, lon: -73.87 },
  "10473": { lat: 40.815, lon: -73.85 }, "10474": { lat: 40.8, lon: -73.89 },
  "10475": { lat: 40.87, lon: -73.82 },
  // Staten Island
  "10301": { lat: 40.6348, lon: -74.0921 }, "10302": { lat: 40.634, lon: -74.1351 },
  "10303": { lat: 40.625, lon: -74.15 }, "10304": { lat: 40.612, lon: -74.0827 },
  "10305": { lat: 40.598, lon: -74.0763 }, "10306": { lat: 40.575, lon: -74.1166 },
  "10307": { lat: 40.51, lon: -74.25 }, "10308": { lat: 40.55, lon: -74.14 },
  "10309": { lat: 40.52, lon: -74.22 }, "10310": { lat: 40.636, lon: -74.113 },
  "10312": { lat: 40.56, lon: -74.17 }, "10314": { lat: 40.6146, lon: -74.1557 },
};

export const zipToCityState: Record<string, { city: string; state: string }> = {
  // Manhattan
  "10001": { city: "New York", state: "NY" },
  "10002": { city: "New York", state: "NY" },
  "10003": { city: "New York", state: "NY" },
  "10004": { city: "New York", state: "NY" },
  "10005": { city: "New York", state: "NY" },
  "10006": { city: "New York", state: "NY" },
  "10007": { city: "New York", state: "NY" },
  "10009": { city: "New York", state: "NY" },
  "10010": { city: "New York", state: "NY" },
  "10011": { city: "New York", state: "NY" },
  "10012": { city: "New York", state: "NY" },
  "10013": { city: "New York", state: "NY" },
  "10014": { city: "New York", state: "NY" },
  "10016": { city: "New York", state: "NY" },
  "10017": { city: "New York", state: "NY" },
  "10018": { city: "New York", state: "NY" },
  "10019": { city: "New York", state: "NY" },
  "10020": { city: "New York", state: "NY" },
  "10021": { city: "New York", state: "NY" },
  "10022": { city: "New York", state: "NY" },
  "10023": { city: "New York", state: "NY" },
  "10024": { city: "New York", state: "NY" },
  "10025": { city: "New York", state: "NY" },
  "10026": { city: "New York", state: "NY" },
  "10027": { city: "New York", state: "NY" },
  "10028": { city: "New York", state: "NY" },
  "10029": { city: "New York", state: "NY" },
  "10030": { city: "New York", state: "NY" },
  "10031": { city: "New York", state: "NY" },
  "10032": { city: "New York", state: "NY" },
  "10033": { city: "New York", state: "NY" },
  "10034": { city: "New York", state: "NY" },
  "10035": { city: "New York", state: "NY" },
  "10036": { city: "New York", state: "NY" },
  "10037": { city: "New York", state: "NY" },
  "10038": { city: "New York", state: "NY" },
  "10039": { city: "New York", state: "NY" },
  "10040": { city: "New York", state: "NY" },
  "10044": { city: "New York", state: "NY" },
  "10065": { city: "New York", state: "NY" },
  "10075": { city: "New York", state: "NY" },
  "10128": { city: "New York", state: "NY" },
  "10280": { city: "New York", state: "NY" },
  "10282": { city: "New York", state: "NY" },
  // Brooklyn
  "11201": { city: "Brooklyn", state: "NY" },
  "11203": { city: "Brooklyn", state: "NY" },
  "11204": { city: "Brooklyn", state: "NY" },
  "11205": { city: "Brooklyn", state: "NY" },
  "11206": { city: "Brooklyn", state: "NY" },
  "11207": { city: "Brooklyn", state: "NY" },
  "11208": { city: "Brooklyn", state: "NY" },
  "11209": { city: "Brooklyn", state: "NY" },
  "11210": { city: "Brooklyn", state: "NY" },
  "11211": { city: "Brooklyn", state: "NY" },
  "11212": { city: "Brooklyn", state: "NY" },
  "11213": { city: "Brooklyn", state: "NY" },
  "11214": { city: "Brooklyn", state: "NY" },
  "11215": { city: "Brooklyn", state: "NY" },
  "11216": { city: "Brooklyn", state: "NY" },
  "11217": { city: "Brooklyn", state: "NY" },
  "11218": { city: "Brooklyn", state: "NY" },
  "11219": { city: "Brooklyn", state: "NY" },
  "11220": { city: "Brooklyn", state: "NY" },
  "11221": { city: "Brooklyn", state: "NY" },
  "11222": { city: "Brooklyn", state: "NY" },
  "11223": { city: "Brooklyn", state: "NY" },
  "11224": { city: "Brooklyn", state: "NY" },
  "11225": { city: "Brooklyn", state: "NY" },
  "11226": { city: "Brooklyn", state: "NY" },
  "11228": { city: "Brooklyn", state: "NY" },
  "11229": { city: "Brooklyn", state: "NY" },
  "11230": { city: "Brooklyn", state: "NY" },
  "11231": { city: "Brooklyn", state: "NY" },
  "11232": { city: "Brooklyn", state: "NY" },
  "11233": { city: "Brooklyn", state: "NY" },
  "11234": { city: "Brooklyn", state: "NY" },
  "11235": { city: "Brooklyn", state: "NY" },
  "11236": { city: "Brooklyn", state: "NY" },
  "11237": { city: "Brooklyn", state: "NY" },
  "11238": { city: "Brooklyn", state: "NY" },
  "11239": { city: "Brooklyn", state: "NY" },
  // Queens
  "11004": { city: "Glen Oaks", state: "NY" },
  "11101": { city: "Long Island City", state: "NY" },
  "11102": { city: "Astoria", state: "NY" },
  "11103": { city: "Astoria", state: "NY" },
  "11104": { city: "Sunnyside", state: "NY" },
  "11105": { city: "Astoria", state: "NY" },
  "11106": { city: "Astoria", state: "NY" },
  "11354": { city: "Flushing", state: "NY" },
  "11355": { city: "Flushing", state: "NY" },
  "11356": { city: "College Point", state: "NY" },
  "11357": { city: "Whitestone", state: "NY" },
  "11358": { city: "Flushing", state: "NY" },
  "11360": { city: "Flushing", state: "NY" },
  "11361": { city: "Bayside", state: "NY" },
  "11362": { city: "Little Neck", state: "NY" },
  "11363": { city: "Little Neck", state: "NY" },
  "11364": { city: "Oakland Gardens", state: "NY" },
  "11365": { city: "Fresh Meadows", state: "NY" },
  "11366": { city: "Fresh Meadows", state: "NY" },
  "11367": { city: "Flushing", state: "NY" },
  "11368": { city: "Corona", state: "NY" },
  "11369": { city: "East Elmhurst", state: "NY" },
  "11370": { city: "East Elmhurst", state: "NY" },
  "11372": { city: "Jackson Heights", state: "NY" },
  "11373": { city: "Elmhurst", state: "NY" },
  "11374": { city: "Rego Park", state: "NY" },
  "11375": { city: "Forest Hills", state: "NY" },
  "11377": { city: "Woodside", state: "NY" },
  "11378": { city: "Maspeth", state: "NY" },
  "11379": { city: "Middle Village", state: "NY" },
  "11385": { city: "Ridgewood", state: "NY" },
  "11412": { city: "Saint Albans", state: "NY" },
  "11413": { city: "Springfield Gardens", state: "NY" },
  "11414": { city: "Howard Beach", state: "NY" },
  "11415": { city: "Kew Gardens", state: "NY" },
  "11416": { city: "Ozone Park", state: "NY" },
  "11417": { city: "Ozone Park", state: "NY" },
  "11418": { city: "Richmond Hill", state: "NY" },
  "11419": { city: "South Richmond Hill", state: "NY" },
  "11420": { city: "South Ozone Park", state: "NY" },
  "11421": { city: "Woodhaven", state: "NY" },
  "11422": { city: "Rosedale", state: "NY" },
  "11423": { city: "Hollis", state: "NY" },
  "11426": { city: "Bellerose", state: "NY" },
  "11427": { city: "Queens Village", state: "NY" },
  "11428": { city: "Queens Village", state: "NY" },
  "11429": { city: "Queens Village", state: "NY" },
  "11432": { city: "Jamaica", state: "NY" },
  "11433": { city: "Jamaica", state: "NY" },
  "11434": { city: "Jamaica", state: "NY" },
  "11435": { city: "Jamaica", state: "NY" },
  "11436": { city: "Jamaica", state: "NY" },
  "11691": { city: "Far Rockaway", state: "NY" },
  "11692": { city: "Arverne", state: "NY" },
  "11693": { city: "Far Rockaway", state: "NY" },
  "11694": { city: "Rockaway Park", state: "NY" },
  "11697": { city: "Breezy Point", state: "NY" },
  // Bronx
  "10451": { city: "Bronx", state: "NY" },
  "10452": { city: "Bronx", state: "NY" },
  "10453": { city: "Bronx", state: "NY" },
  "10454": { city: "Bronx", state: "NY" },
  "10455": { city: "Bronx", state: "NY" },
  "10456": { city: "Bronx", state: "NY" },
  "10457": { city: "Bronx", state: "NY" },
  "10458": { city: "Bronx", state: "NY" },
  "10459": { city: "Bronx", state: "NY" },
  "10460": { city: "Bronx", state: "NY" },
  "10461": { city: "Bronx", state: "NY" },
  "10462": { city: "Bronx", state: "NY" },
  "10463": { city: "Bronx", state: "NY" },
  "10464": { city: "Bronx", state: "NY" },
  "10465": { city: "Bronx", state: "NY" },
  "10466": { city: "Bronx", state: "NY" },
  "10467": { city: "Bronx", state: "NY" },
  "10468": { city: "Bronx", state: "NY" },
  "10469": { city: "Bronx", state: "NY" },
  "10470": { city: "Bronx", state: "NY" },
  "10471": { city: "Bronx", state: "NY" },
  "10472": { city: "Bronx", state: "NY" },
  "10473": { city: "Bronx", state: "NY" },
  "10474": { city: "Bronx", state: "NY" },
  "10475": { city: "Bronx", state: "NY" },
  // Staten Island
  "10301": { city: "Staten Island", state: "NY" },
  "10302": { city: "Staten Island", state: "NY" },
  "10303": { city: "Staten Island", state: "NY" },
  "10304": { city: "Staten Island", state: "NY" },
  "10305": { city: "Staten Island", state: "NY" },
  "10306": { city: "Staten Island", state: "NY" },
  "10307": { city: "Staten Island", state: "NY" },
  "10308": { city: "Staten Island", state: "NY" },
  "10309": { city: "Staten Island", state: "NY" },
  "10310": { city: "Staten Island", state: "NY" },
  "10312": { city: "Staten Island", state: "NY" },
  "10314": { city: "Staten Island", state: "NY" },
};
